// src/dateFormats.ts
var dateFormats = {
  YEAR_MONTH_DAY_DASHED: "yyyy-MM-dd",
  YEAR_MONTH_DAY_SHORT: "yyMMdd",
  YEAR_MONTH_DAY_SHORT_DASHED: "yy-MM-dd",
  YEAR_MONTH_DAY_FULL: "yyyyMMdd",
  YEAR_MONTH_DASHED: "yyyy-MM",
  YEAR_MONTH_SHORT: "yyMM",
  YEAR_MONTH_FULL: "yyyyMM"
};
var dateFormats_default = dateFormats;
export {
  dateFormats_default as dateFormats
};
